<template>
  <v-banner two-line v-on:click="alert" class="text-center">
    <p v-on:click="alert" class="pa-0 ma-0 banner-text">
      Join our newsletter and receive a promo code for 10% off your next points
      purchase!!
    </p>
  </v-banner>
</template>

<script>
var ml_webform_3435970 = ml_account('webforms', '3435970', 'u9n5i5', 'load');
ml_webform_3435970('animation', 'fadeIn');
export default {
  methods: {
    alert() {
      ml_webform_3435970('show');
    }
  }
};
</script>

<style>
.banner-text {
  cursor: pointer;
}

.banner-text:hover {
  color: #354093;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue